
export default {
	data() {
		return {};
	},
	created() {
		this.$router.push("/services");
	},
};
